import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import {RudderstackService} from '../../services/rudderstack.service';
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {NgxTolgeeModule} from "@tolgee/ngx";

@Component({
    selector: 'app-producer-follow-edit-btn',
    templateUrl: './producer-follow-edit-btn.component.html',
    styleUrls: ['./producer-follow-edit-btn.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule, NgxTolgeeModule]
})
export class ProducerFollowEditBtnComponent implements OnInit {
  @Input() producerId: number;
  @Input() userId: number = null;
  @Input() eventId: any;
  @Input() page: string;
  @Input() isFollowing: boolean = false;
  @Output() updateFollowers: EventEmitter<any> = new EventEmitter();

  disableFollowButton = false;

  constructor(
    public authService: AuthService,
    private dialogService: DialogService,
    private userService: UserService,
    public rudderstackService: RudderstackService
  ) { }

  ngOnInit() {
  }

  updateFollowProducer(action) {
    if (!this.userId) {
      this.userService.openLoginModal();
      return;
    }
    if (this.userId === this.producerId) {
      return;
    }
    if ((!this.isFollowing && action === 'follow') || (this.isFollowing && action === 'unfollow')) {
      this.disableFollowButton = true;
      this.userService.updateFollowProducer({userId: this.userId, producerId: this.producerId, action: action}).subscribe(
        (response: any) => {
          this.disableFollowButton = false;
          if(action === 'follow') {
            this.rudderSubscribeToProducer(true);
          } else {
            this.rudderSubscribeToProducer(false);
          }
          this.setFollowers(action);
        }, error => {
          this.disableFollowButton = false;
          this.dialogService.alertsModal('errors', error.code, 3000, false);
        }
      );
    }
  }

  setFollowers(action) {
    this.updateFollowers.emit({producer_id: this.producerId, event_id: this.eventId, action});
  }


  rudderSubscribeToProducer(subscribe_status) {
    this.rudderstackService.track('Subscribe to producer', {
      subscribe_status: subscribe_status,
      user_id: this.userId,
      producer_id: this.producerId,
      event_id: this.eventId
    })
  }

}
